import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Textarea = forwardRef(({ title, name, value, placeholder, required = false, error, handleChange, rows = 4, ...props }, ref) => {
  if (!placeholder) {
    placeholder = title;
  }
  return (
    <>
      {title && (
        <label className="block mb-2 text-sm font-medium text-gray-900" htmlFor={name}>
          {title}{required ? '*' : ''}
        </label>
      )}
      <textarea
        ref={ref}
        name={name}
        id={name}
        value={value || ''}
        className="bg-gray-50 border border-gray-300 text-gray-900 transition-all rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2"
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        rows={rows}
        {...props}
      />
      {error && <p className="text-red-500 text-sm" role="alert" aria-live="polite">{error}</p>}
    </>
  );
});

Textarea.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  rows: PropTypes.number,
};

Textarea.displayName = 'Textarea';

export default Textarea;